// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"aU486u","external":"bU486u","content":"cU486u","grid":"dU486u"};